import type { Book } from './bookTypes'

export type { Book } from './bookTypes'

export const bookData: Book[] = [
  {
    id: 'glp1-nutrition-guide',
    title: 'The GLP-1 Nutrition Guide',
    subtitle: 'Structured Nutrition for Sustainable Results',
    description:
      'A 40+ page comprehensive framework for navigating GLP-1 medications. Protect muscle mass, manage side effects, and build habits that outlast the prescription.',
    pages: '40+ pages',
    status: 'available',
    coverVariant: 'charcoal',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/bgMXNyAARKby8jsfUYuzdX/The_Pure_Bodybuilding_Nutrition_Booklet_-_Fork___Magic_Patterns-1.png',
    badge: 'Bestseller',
    // Resolved server-side via Stripe lookup_key so price changes in Stripe
    // don't require a code redeploy.
    lookupKey: 'glp1_guide',
    priceCents: 100,
  },
  {
    id: 'protein-playbook',
    title: 'The Protein Playbook',
    subtitle: 'Hit Your Targets at Every Stage of Life',
    description:
      'A practical guide to optimizing protein intake for muscle preservation, body composition, and metabolic health.',
    pages: 'Coming 2026',
    status: 'coming-soon',
    coverVariant: 'burgundy',
  },
  {
    id: 'metabolic-reset',
    title: 'The Metabolic Reset',
    subtitle: 'Transitioning Off Weight Loss Medications',
    description:
      'A step-down protocol for maintaining results when stepping down or stopping GLP-1 therapy.',
    pages: 'Coming 2026',
    status: 'coming-soon',
    coverVariant: 'navyslate',
  },
]
